
import axios from 'axios';
import store from '../store';
import { HOST_URL } from './api';

export const IS = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ODkwNDEsImVtYWlsSWQiOiJuaWtoaWwuYWdhcndhbEB0YWdnYm94LmNvbSIsImRiX3RhYmxlIjoicG9zdHNfMjlfbV9uIiwiUk9JVmFsdWUiOjE1MCwiaWF0IjoxNjc1OTIwNjQyLCJleHAiOjE2ODM2OTY2NDJ9.X5L-sbYbV53J6fIGHyRNd8NRnrvSFTV2LKYIlWAEXt8"
const conditions = ['profile', 'transactions', 'notifications', 'expire', 'check_session', 'buystartupplan'];

const getToken = () => {
    const path = window.location.pathname;
    const { collabratorSection, showPlanSection, displayModalSection } = store.getState();
    const { showPricingD } = displayModalSection;
    const { showPricing } = showPlanSection;

    if ((showPricing || showPricingD) && collabratorSection.collabratorList.length > 0) {
        return localStorage.getItem('access_token');
    }

    if (JSON.parse(localStorage.getItem('isCollaborator') ? localStorage.getItem('isCollaborator') : "0") != 0 && !(conditions.some(el => path.includes(el)))) {
        const token = collabratorSection.selectedCollabratorToken != null ? collabratorSection.selectedCollabratorToken : collabratorSection.collabratorList.length > 0 ? collabratorSection.collabratorList.filter((collab) => collab.userId === JSON.parse(localStorage.getItem('ownerId')))[0] : localStorage.getItem('access_token');
        return token;
    }
    return localStorage.getItem('access_token') ? localStorage.getItem('access_token') : localStorage.getItem('authToken');

}


const requestInterceptor = (config) => {
    var headers = {}
    const token = getToken();
    headers = (localStorage.getItem('access_token') || localStorage.getItem("authToken")) ? {
        'authorization': `Bearer ${token}`,
        'ownerId': localStorage.getItem('ownerId'),
        'loginOwnerId': localStorage.getItem('loginOwnerId'),
        'isCollaborator': localStorage.getItem('isCollaborator'),
        'type': 4
    } : {
        'authorization': 'Bearer ' + IS,
        'ownerId': 26359,
        'loginOwnerId': 26359,
        'isCollaborator': 0,
    }
    return {
        ...config,
        headers: {
            ...config.headers,
            ...headers

        },
    }
};

let sessionExpired = false;

class HttpClient {
    constructor() {
        const options = { baseURL: HOST_URL };
        const instance = axios.create(options);
        instance.interceptors.request.use(requestInterceptor);
        instance.interceptors.response.use(
            function (response) {
                return response;
            },
            function (error) {
                if (error.response && error.response.status == 419) {
                    // ek 419 pe hi session clear karo. Warna pehla 419 localStorage clear kar deta hai
                    // aur baaki in-flight requests bina token jaakar dobara 419 deti hain (cascade).
                    // Auth flows (verifyemail/redirectlogin/confirmaccount) me token abhi ban hi raha hota
                    // hai, isliye wahan hard redirect nahi karna - wo flow apna error khud handle karta hai.
                    const isAuthFlow = ['accounts/verifyemail', 'redirectlogin', 'confirmaccount'].some(el => window.location.pathname.includes(el));
                    if (!sessionExpired && !isAuthFlow) {
                        sessionExpired = true;
                        localStorage.clear();
                        window.location.href = 'https://app.socialwalls.com/';
                    }
                }
                return Promise.reject(error);
            }
        );
        return instance;
    }
}
export default HttpClient;
